// extracted by mini-css-extract-plugin
module.exports = {"container":"Boutique_container__2i8-_","content":"Boutique_content__Qz5-o","main":"Boutique_main__1y4bR","sidebar":"Boutique_sidebar__rJCMa"};